module.exports = __webpack_public_path__ + "static/media/AW_250-Mama_desktop_hero_fr.d082c615.jpg";